import {
  LOADING_POPULAR_MEALS,
  POPULAR_MEALS_LOADED,
  POPULAR_MEALS_LOADED_ERROR,
} from "../actions/popularMeals";

const initialState = {
  loading: false,
  loaded: false,
  data: [],
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LOADING_POPULAR_MEALS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POPULAR_MEALS_LOADED:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload,
        error: null,
      };
    case POPULAR_MEALS_LOADED_ERROR:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [],
        error: payload,
      };
    default:
      return state;
  }
};
